<div *ngIf="uploadValid" class="container" style=" border: 1px solid #0076ce;margin: 3rem;">
    <h2 class="dds__h2" style="font-weight: bold; margin: 1rem;">Upload Status
    </h2>
    <div style="margin: 1rem;">
        <div class="fixTableHead dds__table-striped" style="margin: 3rem;overflow: auto; height: auto;
          min-height: 15vh; max-height: 35vh;">
            <table class="dds__table">
                <thead>
                    <tr>
                        <th></th>
                        <th>File Name</th>
                        <th style="text-align: center;">File Cache</th>
                        <th style="text-align: center;">AV Scan</th>
                        <th style="text-align: center;">Agile Upload</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let uploadFile of uploadFiles; let i = index">
                        <tr (click)="uploadFile.statusPanelEnabled = !uploadFile.statusPanelEnabled; setIndex(i,uploadFile)"
                            style="cursor: pointer;">
                            <td style=" width: 10px; font-weight: bolder; color: #00447c;">
                                {{ uploadFile.statusPanelEnabled ? '&ndash;' : '+'}}
                            </td>
                            <td>
                                <span>{{uploadFile.fileName}}</span>
                            </td>
                            <td style="text-align: center;">
                                <span *ngIf="uploadFile.fileCacheStatus == 'complete'">
                                    <svg focusable="false" style="height:25px; max-width: 25px; fill: #6ea204;">
                                        <use xlink:href="#dds__doc-check" />
                                    </svg>
                                </span>
                                <span *ngIf="uploadFile.fileCacheStatus == 'inprogress'">
                                    <div>
                                        <svg class="spinner" width="25px" height="25px" viewBox="0 0 66 66"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round"
                                                cx="33" cy="33" r="30"></circle>
                                        </svg>
                                    </div>
                                </span>
                                <span *ngIf="uploadFile.fileCacheStatus == 'failed'">
                                    <svg focusable="false" style="height:25px; max-width: 25px; fill: #ce1126 ;">
                                        <use xlink:href="#dds__close-cir" />
                                    </svg>
                                </span>
                                <span *ngIf="uploadFile.fileCacheStatus == 'notstarted'">
                                    <svg focusable="false" style="height:25px; max-width: 25px; fill: #f2af00   ;">
                                        <use xlink:href="#dds__pause-sqr" />
                                    </svg>
                                </span>
                            </td>
                            <td style="text-align: center;">
                                <span *ngIf="uploadFile.avScanStatus == 'complete'">
                                    <svg focusable="false" style="height:25px; max-width: 25px; fill: #6ea204;">
                                        <use xlink:href="#dds__doc-check" />
                                    </svg>
                                </span>
                                <span *ngIf="uploadFile.avScanStatus == 'inprogress'">
                                    <div>
                                        <svg class="spinner" width="25px" height="25px" viewBox="0 0 66 66"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round"
                                                cx="33" cy="33" r="30"></circle>
                                        </svg>
                                    </div>
                                </span>
                                <span *ngIf="uploadFile.avScanStatus == 'failed'">
                                    <svg focusable="false" style="height:25px; max-width: 25px; fill: #ce1126 ;">
                                        <use xlink:href="#dds__close-cir" />
                                    </svg>
                                </span>
                                <span *ngIf="uploadFile.avScanStatus == 'notstarted'">
                                    <svg focusable="false" style="height:25px; max-width: 25px; fill: #f2af00   ;">
                                        <use xlink:href="#dds__pause-sqr" />
                                    </svg>
                                </span>
                            </td>
                            <td style="text-align: center;">
                                <span *ngIf="uploadFile.agileUploadStatus == 'complete'">
                                    <svg focusable="false" style="height:25px; max-width: 25px; fill: #6ea204;">
                                        <use xlink:href="#dds__doc-check" />
                                    </svg>
                                </span>
                                <span *ngIf="uploadFile.agileUploadStatus == 'inprogress'">
                                    <div>
                                        <svg class="spinner" width="25px" height="25px" viewBox="0 0 66 66"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round"
                                                cx="33" cy="33" r="30"></circle>
                                        </svg>
                                    </div>
                                </span>
                                <span *ngIf="uploadFile.agileUploadStatus == 'failed'">
                                    <svg focusable="false" style="height:25px; max-width: 25px; fill: #ce1126 ;">
                                        <use xlink:href="#dds__close-cir" />
                                    </svg>
                                </span>
                                <span *ngIf="uploadFile.agileUploadStatus == 'notstarted'">
                                    <svg focusable="false" style="height:25px; max-width: 25px; fill: #f2af00   ;">
                                        <use xlink:href="#dds__pause-sqr" />
                                    </svg>
                                </span>
                            </td>
                        </tr>

                        <ng-container *ngIf="uploadFile.statusPanelEnabled">
                            <tr *ngFor="let details of findDetails(uploadFile)">
                                <td style="padding-left: 12px;"> </td>
                                <td style="padding-left: 12px;"> </td>
                                <td style="text-align: center; word-break: break-all; width: 20rem;">
                                    <div>
                                        <div *ngIf="details.acceleratedTransfer">
                                            <div> Transfer Rate(kbps):
                                                <span>{{details.fileCacheMessage.Transfer_Rate}}</span></div>
                                            <div>Percentage Complete:
                                                <span>{{details.fileCacheMessage.Current_Percent}}</span></div>
                                            <div>Time Remaining(minutes):
                                                <span>{{details.fileCacheMessage.Time_Remaining}}</span></div>
                                            <div>Transfer Mode: <span>{{details.fileCacheMessage.Transfer_Mode}}</span>
                                            </div>
                                        </div>
                                        <div *ngIf="!details.acceleratedTransfer">
                                            {{details.fileCacheMessage.upload_message}}
                                        </div>
                                    </div>
                                </td>
                                <td style="text-align: center; word-break: break-all; width: 20rem;">
                                    {{details.avsScanMessage}} </td>
                                <td style="text-align: center; word-break: break-all; width: 20rem;">
                                    {{details.agileUploadMessage}} </td>
                            </tr>
                        </ng-container>
                    </ng-container>
                </tbody>
            </table>
        </div>
    </div>

</div>

<div *ngIf="downloadValid" class="container" style=" border: 1px solid #0076ce;margin: 3rem;">
    <h2 class="dds__h2" style="font-weight: bold; margin: 1rem;">Download Status
    </h2>
    <div style="margin: 1rem;">
        <div class="fixTableHead dds__table-striped" style="margin: 3rem;overflow: auto; height: auto;
          min-height: 15vh; max-height: 35vh;">
            <table class="dds__table">
                <thead>

                    <tr>
                        <th></th>
                        <th>File Name</th>
                        <th style="text-align: center;">Initial Process</th>
                        <th style="text-align: center;">Download Progress</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let downloadFile of downloadFiles; let i = index">
                        <tr (click)="downloadFile.statusPanelEnabled = !downloadFile.statusPanelEnabled; "
                            style="cursor: pointer;">
                            <td style=" width: 10px; font-weight: bolder; color: #00447c;">
                                {{ downloadFile.statusPanelEnabled ? '&ndash;' : '+'}}
                            </td>
                            <td>
                                <span>{{downloadFile.fileName}}</span>
                            </td>
                            <td style="text-align: center;">
                                <span *ngIf="downloadFile.agileDownloadStatus == 'complete'">
                                    <svg focusable="false" style="height:25px; max-width: 25px; fill: #6ea204;">
                                        <use xlink:href="#dds__doc-check" />
                                    </svg>
                                </span>
                                <span *ngIf="downloadFile.agileDownloadStatus == 'inprogress'">
                                    <div>
                                        <svg class="spinner" width="25px" height="25px" viewBox="0 0 66 66"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round"
                                                cx="33" cy="33" r="30"></circle>
                                        </svg>
                                    </div>
                                </span>
                                <span *ngIf="downloadFile.agileDownloadStatus == 'failed'">
                                    <svg focusable="false" style="height:25px; max-width: 25px; fill: #ce1126 ;">
                                        <use xlink:href="#dds__close-cir" />
                                    </svg>
                                </span>
                                <span *ngIf="downloadFile.agileDownloadStatus == 'notstarted'">
                                    <svg focusable="false" style="height:25px; max-width: 25px; fill: #f2af00   ;">
                                        <use xlink:href="#dds__pause-sqr" />
                                    </svg>
                                </span>
                            </td>
                            <td style="text-align: center;">
                                <span *ngIf="downloadFile.fcDownloadStatus == 'complete'">
                                    <svg focusable="false" style="height:25px; max-width: 25px; fill: #6ea204;">
                                        <use xlink:href="#dds__doc-check" />
                                    </svg>
                                </span>
                                <span *ngIf="downloadFile.fcDownloadStatus == 'inprogress'">

                                    <div>
                                        <svg class="spinner" width="25px" height="25px" viewBox="0 0 66 66"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round"
                                                cx="33" cy="33" r="30"></circle>
                                        </svg>
                                    </div>
                                </span>
                                <span *ngIf="downloadFile.fcDownloadStatus == 'failed'">
                                    <svg focusable="false" style="height:25px; max-width: 25px; fill: #ce1126 ;">
                                        <use xlink:href="#dds__close-cir" />
                                    </svg>
                                </span>
                                <span *ngIf="downloadFile.fcDownloadStatus == 'notstarted'">
                                    <svg focusable="false" style="height:25px; max-width: 25px; fill: #f2af00   ;">
                                        <use xlink:href="#dds__pause-sqr" />
                                    </svg>
                                </span>
                            </td>
                        </tr>

                        <ng-container *ngIf="downloadFile.statusPanelEnabled">
                            <tr *ngFor="let details of findDownloadDetails(downloadFile)">
                                <td style="padding-left: 12px;"> </td>
                                <td style="padding-left: 12px;"> </td>
                                <td style="text-align: center; word-break: break-all; width: 20rem;">
                                    {{details.agileDownloadMessage}} </td>
                                <td style="text-align: center; word-break: break-all; width: 20rem;">
                                    <div>
                                        <div *ngIf="details.acceleratedTransfer">
                                            <div>Download Location:
                                                <span>{{details.fileDownloadMessage.Download_Location}}</span></div>
                                            <div> Transfer Rate(kbps):
                                                <span>{{details.fileDownloadMessage.Transfer_Rate}}</span></div>
                                            <div>Percentage Complete:
                                                <span>{{details.fileDownloadMessage.Current_Percent}}</span></div>
                                            <div>Time Remaining(minutes):
                                                <span>{{details.fileDownloadMessage.Time_Remaining}}</span></div>
                                            <div>Transfer Mode:
                                                <span>{{details.fileDownloadMessage.Transfer_Mode}}</span></div>
                                        </div>
                                        <div *ngIf="!details.acceleratedTransfer">
                                            {{details.fileDownloadMessage.download_message}}
                                        </div>
                                    </div>
                                </td>

                            </tr>
                        </ng-container>



                    </ng-container>
                </tbody>
            </table>
        </div>
    </div>

</div>
<div *ngIf="!uploadValid && downloadValid" class="container" style=" margin: 3rem;">
    <p style="text-align: left;">*No Uploads in progress</p>
</div>
<div *ngIf="uploadValid && !downloadValid" class="container" style=" margin: 3rem;">
    <p style="text-align: left;">*No Downloads in progress</p>
</div>
<div *ngIf="!uploadValid && !downloadValid" class="container" style=" margin: 3rem;">
    <p style="text-align: center; margin-top: 10%; font-weight: bold;">Checking for Active Transfers...</p>
</div>